// extracted by mini-css-extract-plugin
module.exports = {"total":"TaskTotalHours_total__sFAJH","is_over":"TaskTotalHours_is_over__3dHJn"};